import {
  createOidcSession,
  getOidcBootstrap,
  logout,
  refreshToken,
  validateSession,
} from './auth-session.api';

export { type AuthUser, type RefreshResponse, type ValidateResponse } from './auth.types';

export const authApi = {
  getOidcBootstrap,
  createOidcSession,
  validateSession,
  refreshToken,
  logout,
};

export default authApi;
